import { ButtonRowCenter } from '@shared/components/core/card/CommonCardStyles';
import SubSectionRow from '@shared/components/core/headers/SubSectionRow';
import LicenseExpiredBannerCard from '@shared/components/license/LicenseExpiredBannerCard';
import SplashLoader from '@shared/components/loading/SplashLoader';
import useCurrentOrgDetailsFetching from '@shared/hooks/useCurrentOrgDetailsFetching';
import useCurrentOrgProjectsFetching from '@shared/hooks/useCurrentOrgProjectsFetching';
import { useTranslation } from 'react-i18next';
import OrgNoAccessBanner from '../banners/OrgNoAccessBanner';
import ClientActionRow from './client/ClientActionRow';
import ClientCreateAccess from './client/ClientCreateAccess';
import CreateDeviceTypeAccess from './deviceType/CreateDeviceTypeAccess';
import DeviceTypeActionRow from './deviceType/DeviceTypeActionRow';
import ProjectEmptyBanner from './ProjectsEmptyBanner';
import ProjectsUpgradeBanner from './ProjectsUpgradeBanner';

export default function ProjectsPageContent() {
    const { t } = useTranslation();
    const { currentOrg, isExpiredOrg, canManageBilling, canCreateAuthClients, isLoading, isManagedOrg } =
        useCurrentOrgDetailsFetching();
    const { authClients, deviceTypes, isLoading: isLoadingProjects } = useCurrentOrgProjectsFetching();

    if (isLoading || isLoadingProjects) return <SplashLoader />;
    if (!currentOrg) return <OrgNoAccessBanner />;
    if (currentOrg.canCreateAuthClients && !canCreateAuthClients) {
        // org can create auth clients, but user doesn't have access
        return <OrgNoAccessBanner />;
    }
    if (!canCreateAuthClients || !currentOrg.isDeveloperAccess) {
        return <ProjectsUpgradeBanner />;
    }
    if (isExpiredOrg) {
        return (
            <LicenseExpiredBannerCard
                organizationId={currentOrg.id}
                canManageBilling={canManageBilling}
                isManagedOrg={isManagedOrg}
                customBillingUrl={currentOrg.customBillingUrl}
            />
        );
    }
    if (authClients.length === 0 && deviceTypes.length === 0) return <ProjectEmptyBanner />;
    return (
        <>
            <SubSectionRow
                title={t('common:organization.projects.clients.title')}
                description={t('common:organization.projects.clients.description')}
            />

            {authClients.map((client) => (
                <ClientActionRow
                    key={client.id}
                    clientId={client.id}
                    title={client.name ?? '-'}
                    createdDate={client.createdDate}
                />
            ))}
            <ButtonRowCenter>
                <ClientCreateAccess />
            </ButtonRowCenter>
            <SubSectionRow
                title={t('common:organization.projects.deviceType.title')}
                description={t('common:organization.projects.deviceType.description')}
            />

            {deviceTypes &&
                deviceTypes.map((device) => (
                    <DeviceTypeActionRow key={device.id} deviceTypeId={device.id} title={device.name ?? device.id} />
                ))}
            <ButtonRowCenter>
                <CreateDeviceTypeAccess />
            </ButtonRowCenter>
        </>
    );
}
